import { ReactComponent as ExcitedBuddy } from '../../assets/icons/buddy-excited.svg';
import { ReactComponent as JoyBuddy } from '../../assets/icons/buddy-joy.svg';
import { ReactComponent as SadBuddy } from '../../assets/icons/buddy-sad.svg';
import { ReactComponent as SorryBuddy } from '../../assets/icons/buddy-sorry.svg';
import { ReactComponent as SurprisedBuddy } from '../../assets/icons/buddy-surprised.svg';
import WelcomeBuddy from '../../assets/icons/buddy-welcome.gif';
import { ReactComponent as ErrorCheckMark } from '../../assets/icons/error-checkmark.svg';
import { ReactComponent as IceCream } from '../../assets/icons/error-ice-cream.svg';
import { ReactComponent as ErrorToaster } from '../../assets/icons/error-toaster.svg';
import { ReactComponent as ErrorImageNE } from '../../assets/icons/ne-error-page.svg';
import { ReactComponent as AlertCircle } from '../../assets/icons/v3/alert-circle.svg';
import { IBdsModalContent } from '../interfaces/bdsModal';
import { IModalContent } from '../interfaces/modal';
import { TRANSLATION_COLLABORATORS } from '../translations/collaborators';
import { TRANSLATIONS_GLOBAL } from '../translations/commons';
import { TRANSLATIONS_HOME } from '../translations/home';
import { TRANSLATIONS_REQUESTS } from '../translations/requests';
import { TRANSLATIONS_SETTINGS } from '../translations/settings';
import { TRANSLATION_STORIES_LIST, TRANSLATION_STORIES_CREATE_NEW } from '../translations/stories';

export const GENERIC_MODAL: IModalContent = {
  ImageComponent: ErrorToaster,
  title: TRANSLATIONS_GLOBAL.modals.generic.title,
  subtitle: TRANSLATIONS_GLOBAL.modals.generic.subtitle,
  description: TRANSLATIONS_GLOBAL.modals.generic.description,
  primaryButton: {
    text: TRANSLATIONS_GLOBAL.modals.generic.primaryButton
  },
  newExperience: true
};

export const GENERIC_RELOAD_MODAL: IModalContent = {
  ImageComponent: ErrorToaster,
  title: TRANSLATIONS_GLOBAL.modals.generic.title,
  subtitle: TRANSLATIONS_GLOBAL.modals.generic.subtitle,
  description: TRANSLATIONS_GLOBAL.modals.generic.description,
  primaryButton: {
    text: TRANSLATIONS_GLOBAL.modals.generic.primaryButton,
    action: () => window.location.reload()
  },
  newExperience: true
};

export const SLACK_INTEGRATION_SUCCESS_MODAL: IModalContent = {
  ImageComponent: ExcitedBuddy,
  title: TRANSLATIONS_SETTINGS.integrations.slack.titleSuccessModal,
  description: TRANSLATIONS_SETTINGS.integrations.slack.textSuccessModal,
  primaryButton: {
    text: TRANSLATIONS_SETTINGS.integrations.slack.buttonSuccessModal
  },
  newExperience: true
};

export const SLACK_INTEGRATION_ERROR_MODAL: IModalContent = {
  ImageComponent: SadBuddy,
  title: TRANSLATIONS_SETTINGS.integrations.slack.titleErrorModal,
  description: TRANSLATIONS_SETTINGS.integrations.slack.textErrorModal,
  primaryButton: {
    text: TRANSLATIONS_SETTINGS.integrations.slack.buttonErrorModal
  },
  newExperience: true
};

export const FIRST_LOGIN_MODAL: IModalContent = {
  imageSrc: WelcomeBuddy,
  title: TRANSLATIONS_HOME.firstLoginModal.title,
  description: TRANSLATIONS_HOME.firstLoginModal.subtitle,
  primaryButton: {
    text: TRANSLATIONS_HOME.firstLoginModal.button
  },
  newExperience: true
};

export const HIDE_STORY_MODAL: IModalContent = {
  ImageComponent: SadBuddy,
  title: TRANSLATION_STORIES_LIST.modal.hideStory.title,
  description: TRANSLATION_STORIES_LIST.modal.hideStory.description,
  primaryButton: {
    text: TRANSLATION_STORIES_LIST.modal.hideStory.primaryButton
  },
  secondaryButton: {
    text: TRANSLATION_STORIES_LIST.modal.hideStory.secondaryButton
  },
  newExperience: true
};

export const PUBLISH_STORY_MODAL: IModalContent = {
  ImageComponent: ExcitedBuddy,
  title: TRANSLATION_STORIES_CREATE_NEW.publishModal.title,
  description: TRANSLATION_STORIES_CREATE_NEW.publishModal.subtitle,
  primaryButton: {
    text: TRANSLATION_STORIES_CREATE_NEW.publishModal.button
  },
  newExperience: true
};

export const PROGRAM_STORY_MODAL: IModalContent = {
  ImageComponent: ExcitedBuddy,
  title: TRANSLATION_STORIES_CREATE_NEW.programModal.title,
  description: TRANSLATION_STORIES_CREATE_NEW.programModal.subtitle,
  primaryButton: {
    text: TRANSLATION_STORIES_CREATE_NEW.programModal.button
  },
  newExperience: true
};

export const STORY_DETAIL_ERROR_MODAL: IModalContent = {
  ImageComponent: ErrorImageNE,
  title: TRANSLATION_STORIES_LIST.modal.storyDetailError.title,
  description: TRANSLATION_STORIES_LIST.modal.storyDetailError.subtitle,
  primaryButton: {
    text: TRANSLATION_STORIES_LIST.modal.storyDetailError.buttonText
  },
  newExperience: true
};

export const EXTERNAL_PAYMENT_ERROR_MODAL: IModalContent = {
  ImageComponent: IceCream,
  title: TRANSLATIONS_HOME.error.payment.title,
  description: TRANSLATIONS_HOME.error.payment.description,
  primaryButton: {
    text: TRANSLATIONS_HOME.error.payment.buttonText
  },
  newExperience: true
};

export const DEFAULT_BDS_MODAL: IBdsModalContent = {
  icon: JoyBuddy,
  title: '',
  description: '',
  primaryActionText: '',
  secondaryActionText: '',
  footnote: ''
};

export const UPGRADE_PLAN_MODAL: IBdsModalContent = {
  icon: JoyBuddy,
  title: TRANSLATIONS_GLOBAL.modals.upgradePlan.title,
  description: TRANSLATIONS_GLOBAL.modals.upgradePlan.description,
  primaryActionText: TRANSLATIONS_GLOBAL.modals.upgradePlan.primaryButton
};

export const UPGRADE_PROTECTION_MODAL: IBdsModalContent = {
  icon: JoyBuddy,
  title: TRANSLATIONS_GLOBAL.modals.upgradeProtection.title,
  description: TRANSLATIONS_GLOBAL.modals.upgradeProtection.description,
  primaryActionText: TRANSLATIONS_GLOBAL.modals.upgradeProtection.primaryButton
};

export const UPGRADE_BENEFITS_MODAL: IBdsModalContent = {
  icon: JoyBuddy,
  title: TRANSLATIONS_GLOBAL.modals.upgradeBenefits.title,
  description: TRANSLATIONS_GLOBAL.modals.upgradeBenefits.description,
  primaryActionText: TRANSLATIONS_GLOBAL.modals.upgradeBenefits.primaryButton
};

export const APPROVE_RF_REQUEST_MODAL: IBdsModalContent = {
  icon: JoyBuddy,
  title: TRANSLATIONS_REQUESTS.details.modals.approve.title,
  description: TRANSLATIONS_REQUESTS.details.modals.approve.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.approve.primaryButton,
  secondaryActionText: TRANSLATIONS_REQUESTS.details.modals.approve.secondaryButton,
  primaryLoadingType: 'left',
  primaryLoadingText: TRANSLATIONS_REQUESTS.details.modals.approve.primaryButtonLoadingText
};

export const REJECT_RF_REQUEST_MODAL: IBdsModalContent = {
  icon: SurprisedBuddy,
  title: TRANSLATIONS_REQUESTS.details.modals.reject.title,
  description: TRANSLATIONS_REQUESTS.details.modals.reject.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.reject.primaryButton,
  secondaryActionText: TRANSLATIONS_REQUESTS.details.modals.reject.secondaryButton
};

export const CANCEL_RF_TRAINING_REQUEST_MODAL: IBdsModalContent = {
  icon: SurprisedBuddy,
  title: TRANSLATIONS_REQUESTS.details.modals.cancel.title,
  description: TRANSLATIONS_REQUESTS.details.modals.cancel.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.cancel.primaryButton,
  secondaryActionText: TRANSLATIONS_REQUESTS.details.modals.cancel.secondaryButton
};

export const CANCEL_RF_HEALTH_REQUEST_MODAL: IBdsModalContent = {
  icon: SurprisedBuddy,
  title: TRANSLATIONS_REQUESTS.details.modals.cancel.healthTitle,
  description: TRANSLATIONS_REQUESTS.details.modals.cancel.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.cancel.healthPrimaryButton,
  secondaryActionText: TRANSLATIONS_REQUESTS.details.modals.cancel.secondaryButton
};

export const REQUEST_SALARY_PERCENTAGE_EXCEDEED_MODAL: IBdsModalContent = {
  icon: AlertCircle,
  title: TRANSLATIONS_REQUESTS.details.modals.errors.common.title,
  description: TRANSLATIONS_REQUESTS.details.modals.errors.salaryPercentage.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.errors.common.button
};

export const REQUEST_ACCUMULATION_LIMIT_EXCEDEED_MODAL: IBdsModalContent = {
  icon: AlertCircle,
  title: TRANSLATIONS_REQUESTS.details.modals.errors.common.title,
  description: TRANSLATIONS_REQUESTS.details.modals.errors.accumulationLimit.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.errors.common.button
};

export const REQUEST_SMI_THRESHOLD_VIOLATION_MODAL: IBdsModalContent = {
  icon: AlertCircle,
  title: TRANSLATIONS_REQUESTS.details.modals.errors.common.title,
  description: TRANSLATIONS_REQUESTS.details.modals.errors.SMIThreshold.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.errors.common.button
};

export const REQUEST_INTERNAL_FLEXIBLE_REMUNERATION_ERROR_MODAL: IBdsModalContent = {
  icon: ErrorCheckMark,
  title: TRANSLATIONS_REQUESTS.details.modals.errors.internalFRError.title,
  description: TRANSLATIONS_REQUESTS.details.modals.errors.internalFRError.description,
  primaryActionText: TRANSLATIONS_REQUESTS.details.modals.errors.internalFRError.buttonPrimary,
  secondaryActionText: TRANSLATIONS_REQUESTS.details.modals.errors.internalFRError.buttonSecondary
};

export const CERTIFICATE_NOT_FOUND_MODAL: IBdsModalContent = {
  icon: SorryBuddy,
  title: TRANSLATION_COLLABORATORS.detail.certificate.notFoundModal.title,
  description: TRANSLATION_COLLABORATORS.detail.certificate.notFoundModal.description,
  primaryActionText: TRANSLATION_COLLABORATORS.detail.certificate.notFoundModal.contactSupport,
  secondaryActionText: TRANSLATION_COLLABORATORS.detail.certificate.notFoundModal.close
};
